export const product = {
  // Hero
  heroTitle: 'Hooked-End Steel Fibers',
  heroSubtitle: 'Premium concrete reinforcement solution engineered for superior performance and durability',

  // Overview
  overviewTitle: 'Product Overview',
  overviewDesc: 'DYNAMIX Hooked-End Steel Fibers are high-performance concrete reinforcement solutions manufactured from premium cold-drawn steel wire. Our fibers feature an optimized hooked-end geometry that provides exceptional anchorage in the concrete matrix, ensuring superior load transfer and crack control.',

  downloadDatasheet: 'Download Technical Datasheet',
  requestQuote: 'Request a Quote',

  // Technical Specs
  specsTitle: 'Technical Specifications',
  specsSubtitle: 'Precision-engineered to meet the most demanding construction requirements.',

  specMaterial: 'Material',
  specMaterialValue: 'Cold-drawn steel wire',

  specTensile: 'Tensile Strength',
  specTensileValue: '1000-1200 MPa',
  specTensileBig: '>1100 MPa',

  specLength: 'Length',
  specLengthValue: '30-60 mm (customizable)',
  specLengthBig: '30-60 mm',

  specDiameter: 'Diameter',
  specDiameterValue: '0.5-1.0 mm',
  specDiameterBig: '0.5-1.0 mm',

  specAspect: 'Aspect Ratio',
  specAspectValue: '45-80',
  specAspectBig: '45-80',

  specDosage: 'Typical Dosage',
  specDosageValue: '20-40 kg/m³',

  specStandard: 'Standard Compliance',
  specStandardValue: 'ASTM A820, TS EN 14889-1',
  specStandardBig: 'ASTM A820',

  specPackaging: 'Packaging',
  specPackagingValue: '20 kg bags, 1000 kg big bags',

  // Key Advantages
  advantagesTitle: 'Key Advantages',

  adv1Title: 'Enhanced Structural Performance',
  adv1Desc: 'Significantly improves concrete\'s post-crack tensile strength and load-bearing capacity.',

  adv2Title: 'Superior Crack Control',
  adv2Desc: 'Three-dimensional fiber network effectively controls both plastic and hardened concrete cracking.',

  adv3Title: 'Increased Durability',
  adv3Desc: 'Extends service life of concrete structures by improving resistance to impact, fatigue, and environmental factors.',

  adv4Title: 'Reduced Construction Time',
  adv4Desc: 'Eliminates time-consuming mesh installation, accelerating project completion.',

  adv5Title: 'Cost Savings',
  adv5Desc: 'Lower labor costs and reduced material waste compared to traditional reinforcement methods.',

  adv6Title: 'Versatile Application',
  adv6Desc: 'Suitable for various concrete applications from industrial floors to tunnel linings.',
};
